import React, { useEffect, useState } from "react";
import { collection, getDocs, addDoc, updateDoc, doc } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";

function CreateLessonFolder() {
  const [folderTitle, setFolderTitle] = useState("");
  const [notes, setNotes] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [students, setStudents] = useState([]);
  const [drafts, setDrafts] = useState([]);
  const [selectedDrafts, setSelectedDrafts] = useState([]);
  const [googleResources, setGoogleResources] = useState([{ name: "", url: "" }]);

  useEffect(() => {
    const fetchStudentsAndDrafts = async () => {
      const usersSnap = await getDocs(collection(db, "users"));
      const studentList = usersSnap.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((user) => user.role === "student");
      setStudents(studentList);

      const draftSnap = await getDocs(collection(db, "assignments"));
      const draftAssignments = draftSnap.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((a) => a.isDraft);
      setDrafts(draftAssignments);
    };

    fetchStudentsAndDrafts();
  }, []);

  const toggleDraftSelection = (id) => {
    setSelectedDrafts((prev) =>
      prev.includes(id) ? prev.filter((d) => d !== id) : [...prev, id]
    );
  };

const handleSaveFolder = async () => {
if (!folderTitle) {
  alert("Please enter a title for the lesson folder.");
  return;
}


  try {
    await addDoc(collection(db, "lessonFolders"), {
      title: folderTitle,
      notes,
      studentUID: selectedStudent || null,
      assignments: selectedDrafts,
      googleResources: googleResources.filter(r => r.name && r.url),
      createdAt: new Date().toISOString(),
    });

   

    alert("✅ Lesson folder saved!");
    setFolderTitle("");
    setNotes("");
    setSelectedDrafts([]);
  } catch (error) {
    console.error("❌ Error saving folder:", error);
    alert("Failed to save lesson folder.");
  }
};


  return (
    <TutorLayout>
     <div style={{
  padding: "2rem",
  maxWidth: "800px",
  margin: "0 auto",
  fontFamily: "Inter, sans-serif",
  backgroundColor: "#f8f9fa",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)"
}}>
  <h2 style={{ marginBottom: "1.5rem", color: "#2d3436" }}>📁 Create Lesson Folder</h2>

  {/* Section: Select Student */}
  <div style={{ marginBottom: "1.5rem" }}>
    <label style={{ fontWeight: "600", display: "block", marginBottom: "0.5rem" }}>👤 Select Student:</label>
    <select
      value={selectedStudent}
      onChange={(e) => setSelectedStudent(e.target.value)}
      style={{
        width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc",
        fontSize: "1rem"
      }}
    >
      <option value="">-- Select Student --</option>
      {students.map((s) => (
        <option key={s.id} value={s.uid}>
          {s.displayName} {s.surname}
        </option>
      ))}
    </select>
  </div>

  {/* Section: Title */}
  <div style={{ marginBottom: "1.5rem" }}>
    <label style={{ fontWeight: "600", display: "block", marginBottom: "0.5rem" }}>📌 Lesson Title:</label>
    <input
      type="text"
      value={folderTitle}
      onChange={(e) => setFolderTitle(e.target.value)}
      placeholder="e.g. Lesson 5 – Fractions"
      style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
    />
  </div>

  {/* Section: Notes */}
  <div style={{ marginBottom: "1.5rem" }}>
    <label style={{ fontWeight: "600", display: "block", marginBottom: "0.5rem" }}>📝 Notes:</label>
    <textarea
      value={notes}
      onChange={(e) => setNotes(e.target.value)}
      placeholder="Optional notes..."
      style={{ width: "100%", padding: "10px", borderRadius: "6px", border: "1px solid #ccc", minHeight: "80px" }}
    />
  </div>

  {/* Section: Google Resources */}
  <div style={{ marginBottom: "2rem", background: "#f1f2f6", padding: "1rem", borderRadius: "8px" }}>
    <h4 style={{ marginBottom: "1rem", fontWeight: "600" }}>📎 Google Drive Resources</h4>
    {googleResources.map((res, index) => (
      <div key={index} style={{ marginBottom: "1rem", display: "flex", gap: "1rem", flexWrap: "wrap" }}>
        <input
          type="text"
          placeholder="Resource name (e.g. 'Fractions Slides')"
          value={res.name}
          onChange={(e) => {
            const updated = [...googleResources];
            updated[index].name = e.target.value;
            setGoogleResources(updated);
          }}
          style={{ flex: "1", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
        />
        <input
          type="text"
          placeholder="Paste Google Drive link"
          value={res.url}
          onChange={(e) => {
            const updated = [...googleResources];
            updated[index].url = e.target.value;
            setGoogleResources(updated);
          }}
          style={{ flex: "2", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
        />
      </div>
    ))}
    <button
      type="button"
      onClick={() => setGoogleResources([...googleResources, { name: "", url: "" }])}
      style={{
        padding: "8px 16px",
        background: "#dfe6e9",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "600"
      }}
    >
      ➕ Add Another Resource
    </button>
  </div>

  {/* Section: Saved Assignments */}
  <div style={{ marginBottom: "2rem", background: "#f1f2f6", padding: "1rem", borderRadius: "8px" }}>
    <h4 style={{ fontWeight: "600", marginBottom: "1rem" }}>📋 Select Saved Assignments</h4>
    {drafts.length === 0 ? (
      <p style={{ fontStyle: "italic", color: "#636e72" }}>No saved drafts found.</p>
    ) : (
      <ul style={{ listStyle: "none", padding: 0 }}>
        {drafts.map((draft) => (
          <li key={draft.id} style={{ marginBottom: "0.5rem" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              <input
                type="checkbox"
                checked={selectedDrafts.includes(draft.id)}
                onChange={() => toggleDraftSelection(draft.id)}
              />
              <span>
                <strong>{draft.title || "(Untitled Assignment)"}</strong> — {draft.subject} ({draft.clip})
              </span>
            </label>
          </li>
        ))}
      </ul>
    )}
  </div>

  {/* Save Button */}
  <button
    onClick={handleSaveFolder}
    style={{
      width: "100%",
      padding: "0.75rem",
      fontSize: "1rem",
      backgroundColor: "#00b894",
      color: "white",
      border: "none",
      borderRadius: "8px",
      fontWeight: "600",
      cursor: "pointer"
    }}
  >
    💾 Save Lesson Folder
  </button>
</div>

    </TutorLayout>
  );
}

export default CreateLessonFolder;
